import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { MainPage } from './components/MainPage'
import { ProductDetails } from './components/Products/ProductDetails'
import { About } from './components/Pages/About'
import { ContactUs } from './components/Pages/ContactUs'
import { Terms } from './components/Pages/Terms'
import { Login } from './components/Pages/Login'
import { Cart } from './components/Cart/Cart'
import { Profile } from './components/Settings/Settings'
import { SignUp } from './components/Pages/SignUp'
import { ForgotPasswordVerificationCodeForm } from './components/LoginForms/ForgotPasswordVerificationCode'
import { ForgotPasswordForm } from './components/LoginForms/ForgotPasswordForm'
import { ResetPasswordForm } from './components/LoginForms/ResetPasswordForm'
import { FullPageSpinner } from './ui/FullPageSpinner'
import { ChangePasswordForm } from './components/Settings/ChangePasswordForm'
import { UpdatePersonalInfoForm } from './components/Settings/UpdatePersonalInfoForm'
import { AddAddressInfoForm } from './components/Settings/AddAddressInfoForm'
import { OrdersList } from './components/orders/OrdersList'
import { OrderDetails } from './components/orders/OrderDetails'
import { ShippingInfoForm } from './components/Cart/ShippingInfo'
import { Payment } from './components/Cart/Payment'
import { ProductRequests } from './components/Pages/ProductRequests'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Unauthorized } from './components/Pages/Unauthorized'
import { NotFound } from './components/Pages/NotFound'
import { WishlistPage } from './components/Pages/WishlistPage'

function App() {
  return (
    <React.Suspense fallback={<FullPageSpinner />}>
      <div className='overflow-hidden w-full'>
        <Layout>
          <Routes>
            <Route path='/' element={<MainPage />} />
            <Route path='/products/:productSlug' element={<ProductDetails />} />
            <Route path='/login' element={<Login />} />
            <Route path='/sign-up' element={<SignUp />} />
            <Route path='/cart' element={<Cart />} />

            {/* Protected Routes - Require Authentication */}
            <Route
              path='/cart/shipping-info'
              element={
                <ProtectedRoute>
                  <ShippingInfoForm />
                </ProtectedRoute>
              }
            />
            <Route
              path='/cart/payment'
              element={
                <ProtectedRoute>
                  <Payment />
                </ProtectedRoute>
              }
            />
            <Route
              path='/orders'
              element={
                <ProtectedRoute>
                  <OrdersList />
                </ProtectedRoute>
              }
            />
            <Route
              path='/orders/:orderId'
              element={
                <ProtectedRoute>
                  <OrderDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path='/settings'
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path='/change-password'
              element={
                <ProtectedRoute>
                  <ChangePasswordForm />
                </ProtectedRoute>
              }
            />
            <Route
              path='/update-personal-info'
              element={
                <ProtectedRoute>
                  <UpdatePersonalInfoForm />
                </ProtectedRoute>
              }
            />
            <Route
              path='/add-address-info'
              element={
                <ProtectedRoute>
                  <AddAddressInfoForm />
                </ProtectedRoute>
              }
            />

            {/* Public Routes */}
            <Route path='/wishlist' element={<WishlistPage />} />
            <Route path='/product-requests' element={<ProductRequests />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact-us' element={<ContactUs />} />
            <Route path='/terms' element={<Terms />} />
            <Route path='/forgot-password' element={<ForgotPasswordForm />} />
            <Route
              path='/forgot-password-verification-code'
              element={<ForgotPasswordVerificationCodeForm />}
            />
            <Route path='/reset-password' element={<ResetPasswordForm />} />

            {/* Error Routes */}
            <Route path='/unauthorized' element={<Unauthorized />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Layout>
      </div>
    </React.Suspense>
  )
}

export default App
